<template>
  <div>
    <b-jumbotron>
      <b-container>
        <h1 v-label-key="'LOGIN_HEADER'">Dashboard Login</h1>
      </b-container>
    </b-jumbotron>
    <b-container class="mt-5">
      <b-row>
        <b-col md="6" offset-md="3">
          <b-form @submit.stop.prevent="login">
            <b-form-group :label="getLabel('EMAIL_ADDRESS')">
              <b-form-input
                v-model="creds.email"
                type="email"
                :placeholder="getLabel('EMAIL_INPUT_PLACEHOLDER')"
              />
            </b-form-group>
            <b-form-group :label="getLabel('PASSWORD')">
              <b-form-input
                v-model="creds.password"
                type="password"
                :placeholder="getLabel('ENTER_PASSWORD')"
              />
            </b-form-group>
            <b-button block variant="primary" type="submit">
              <span v-label-key="'LOGIN'">Login</span>
            </b-button>
            <div class="mt-5">
              <a
                v-router-link="{ name: 'reset-password' }"
                v-label-key="'RESET_PASSWORD'"
                >Reset Password</a
              >
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },
  data() {
    return {
      creds: {},
    };
  },
  methods: {
    login() {
      $api
        .post('/v1/dashboard/tokens', this.creds)
        .then(user => {
          if (user.refresh_token) {
            localStorage.refresh_token = user.refresh_token;
            window.location.href = '/';
          }
        })
        .catch(err => {
          alert(err); // eslint-disable-line no-alert
        });
    },
  },
};
</script>
